import { ActiveScriptCardUnit, CardOption, PassStep } from '@/models/scripts'
import { ActiveScriptState } from './state'
import { MutationTree } from 'vuex'

export enum ActiveScriptMutationTypes {
  Start = '[Active Script Mutation] Start',
  SetStartTime = '[Active Script Mutation] Set Start Time',
  StartCard = '[Active Script Mutation] Start Card',
  HistoryAddStep = '[Active Script Mutation] History Add Step',
  Finish = '[Active Script Mutation] Finish',
}

export type ActiveScriptStartMutationPayload = {
  scriptId: string
}

export type ActiveScriptSetStartTimeMutationPayload = {
  started: number
}

export type ActiveScriptStartCardMutationPayload = {
  scriptId: string
  card: ActiveScriptCardUnit
  history?: PassStep[]
}

export type ActiveScriptHistoryAddStepMutationPayload = {
  fromCard: ActiveScriptCardUnit
  card: ActiveScriptCardUnit
  option: CardOption
}

export const mutations: MutationTree<ActiveScriptState> = {
  [ActiveScriptMutationTypes.Start](
    state,
    payload: ActiveScriptStartMutationPayload,
  ) {
    const { scriptId } = payload

    state.scriptId = scriptId
  },

  [ActiveScriptMutationTypes.SetStartTime](
    state,
    payload: ActiveScriptSetStartTimeMutationPayload,
  ) {
    const { started } = payload

    state.started = started
  },

  [ActiveScriptMutationTypes.StartCard](
    state,
    { scriptId, card, history }: ActiveScriptStartCardMutationPayload,
  ) {
    if (!scriptId) {
      state.cardNumber = undefined
      return
    }

    state.cardNumber = card.num

    if (history) {
      state.history = history
    }

    let cardExist = false

    const cards = (state.cards || []).map(cardIt => {
      if (cardIt.num === card.num) {
        cardExist = true

        return { ...cardIt, ...card }
      } else {
        return cardIt
      }
    })

    if (!cardExist) {
      cards.push(card)
    }

    state.cards = cards
  },

  [ActiveScriptMutationTypes.HistoryAddStep](
    state,
    payload: ActiveScriptHistoryAddStepMutationPayload,
  ): void {
    const { fromCard, card, option } = payload

    const history = state.history || []

    const updatedHistory: PassStep[] = []

    for (let i = 0; i < history.length; i++) {
      const step = history[i]

      if (step.card === fromCard.num) {
        updatedHistory.push({ ...step, opt: option.n })
        break // for new history
      } else {
        updatedHistory.push(step)
      }
    }

    updatedHistory.push({
      opt: null,
      name: card.name,
      step: updatedHistory.length + 1,
      card: card.num,
    })

    state.history = updatedHistory
  },

  [ActiveScriptMutationTypes.Finish](state) {
    state.scriptId = undefined
    state.started = undefined
    state.cardNumber = undefined
  },
}
